// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AdvertisementsAdminControllerCreateManyData,
  AdvertisementsAdminControllerCreateManyResponses,
  AdvertisementsAdminControllerCreateOneData,
  AdvertisementsAdminControllerCreateOneResponses,
  AdvertisementsAdminControllerDeleteOneData,
  AdvertisementsAdminControllerDeleteOneResponses,
  AdvertisementsAdminControllerGetOneData,
  AdvertisementsAdminControllerGetOneResponses,
  AdvertisementsAdminControllerListData,
  AdvertisementsAdminControllerListResponses,
  AdvertisementsAdminControllerUpdateOneData,
  AdvertisementsAdminControllerUpdateOneResponses,
  AdvertisementsControllerCreateData,
  AdvertisementsControllerCreateResponses,
  AdvertisementsControllerFindAllData,
  AdvertisementsControllerFindAllResponses,
  AdvertisementsControllerFindOneData,
  AdvertisementsControllerFindOneResponses,
  AdvertisementsControllerRecordViewData,
  AdvertisementsControllerRecordViewResponses,
  AdvertisementsControllerRemoveData,
  AdvertisementsControllerRemoveResponses,
  AdvertisementsControllerUpdateData,
  AdvertisementsControllerUpdateResponses,
  AnnouncementsAdminControllerCreateData,
  AnnouncementsAdminControllerCreateResponses,
  AnnouncementsAdminControllerFindOneData,
  AnnouncementsAdminControllerFindOneResponses,
  AnnouncementsAdminControllerListData,
  AnnouncementsAdminControllerListResponses,
  AnnouncementsAdminControllerRemoveData,
  AnnouncementsAdminControllerRemoveResponses,
  AnnouncementsAdminControllerUpdateData,
  AnnouncementsAdminControllerUpdateResponses,
  AnnouncementsControllerFindActiveData,
  AnnouncementsControllerFindActiveResponses,
  AppControllerGetMinAppVersionData,
  AppControllerGetMinAppVersionResponses,
  AppControllerStoreData,
  ArtefactsControllerFindOneData,
  ArtefactsControllerFindOneResponses,
  AuthControllerAnonymousLoginData,
  AuthControllerAnonymousLoginResponses,
  AuthControllerChangeEmailData,
  AuthControllerChangeEmailResponses,
  AuthControllerChangePasswordData,
  AuthControllerChangePasswordResponses,
  AuthControllerCheckEmailAvailabilityData,
  AuthControllerCheckEmailAvailabilityResponses,
  AuthControllerCheckPseudoAvailabilityData,
  AuthControllerCheckPseudoAvailabilityResponses,
  AuthControllerFillLoginDetailsData,
  AuthControllerFillLoginDetailsResponses,
  AuthControllerForgotPasswordData,
  AuthControllerForgotPasswordResponses,
  AuthControllerLoginData,
  AuthControllerLoginResponses,
  AuthControllerMeData,
  AuthControllerMeResponses,
  AuthControllerRegisterData,
  AuthControllerRegisterResponses,
  AuthControllerRequestSetEmailData,
  AuthControllerRequestSetEmailResponses,
  AuthControllerResendVerificationEmailData,
  AuthControllerResendVerificationEmailResponses,
  AuthControllerResetPasswordCodeCheckData,
  AuthControllerResetPasswordCodeCheckResponses,
  AuthControllerResetPasswordData,
  AuthControllerResetPasswordResponses,
  AuthControllerVerifyChangeEmailData,
  AuthControllerVerifyChangeEmailResponses,
  AuthControllerVerifyEmailData,
  AuthControllerVerifyEmailResponses,
  AvatarsAdminControllerCreateManyData,
  AvatarsAdminControllerCreateManyResponses,
  AvatarsAdminControllerCreateOneData,
  AvatarsAdminControllerCreateOneResponses,
  AvatarsAdminControllerDeleteOneData,
  AvatarsAdminControllerDeleteOneResponses,
  AvatarsAdminControllerGetOneData,
  AvatarsAdminControllerGetOneResponses,
  AvatarsAdminControllerListData,
  AvatarsAdminControllerListResponses,
  AvatarsAdminControllerUpdateOneData,
  AvatarsAdminControllerUpdateOneResponses,
  AvatarsControllerCreateData,
  AvatarsControllerCreateResponses,
  AvatarsControllerFindAllAuthenticatedData,
  AvatarsControllerFindAllAuthenticatedResponses,
  AvatarsControllerFindAllUnAuthenticatedData,
  AvatarsControllerFindAllUnAuthenticatedResponses,
  AvatarsControllerFindMyAvatarData,
  AvatarsControllerFindMyAvatarResponses,
  AvatarsControllerFindOneData,
  AvatarsControllerFindOneResponses,
  AvatarsControllerRemoveData,
  AvatarsControllerRemoveResponses,
  AvatarsControllerUpdateData,
  AvatarsControllerUpdateMyAvatarData,
  AvatarsControllerUpdateMyAvatarResponses,
  AvatarsControllerUpdateResponses,
  ChatControllerAnswerQuestionData,
  ChatControllerAnswerQuestionResponses,
  ChatControllerCreateChatMessageData,
  ChatControllerCreateChatMessageResponses,
  ChatControllerDeleteChatMessageData,
  ChatControllerDeleteChatMessageResponses,
  ChatControllerEditChatMessageData,
  ChatControllerEditChatMessageResponses,
  ChatControllerFindAllData,
  ChatControllerFindAllResponses,
  ChatControllerGetCryptorChatData,
  ChatControllerGetCryptorChatMessageData,
  ChatControllerGetCryptorChatMessageResponses,
  ChatControllerGetCryptorChatMessagesData,
  ChatControllerGetCryptorChatMessagesResponses,
  ChatControllerGetCryptorChatResponses,
  ChatControllerRegenerateMessageData,
  ChatControllerRegenerateMessageResponses,
  ChatgptControllerCollectQuestionData,
  ChatgptControllerCollectQuestionResponses,
  ChatgptControllerGetCryptorChatGptData,
  ChatgptControllerGetCryptorChatGptResponses,
  ChatMessageAdminControllerCreateManyData,
  ChatMessageAdminControllerCreateManyResponses,
  ChatMessageAdminControllerCreateOneData,
  ChatMessageAdminControllerCreateOneResponses,
  ChatMessageAdminControllerDeleteOneData,
  ChatMessageAdminControllerDeleteOneResponses,
  ChatMessageAdminControllerGetOneData,
  ChatMessageAdminControllerGetOneResponses,
  ChatMessageAdminControllerListData,
  ChatMessageAdminControllerListResponses,
  ChatMessageAdminControllerUpdateOneData,
  ChatMessageAdminControllerUpdateOneResponses,
  CitiesAdminControllerCreateManyData,
  CitiesAdminControllerCreateManyResponses,
  CitiesAdminControllerCreateOneData,
  CitiesAdminControllerCreateOneResponses,
  CitiesAdminControllerDeleteOneData,
  CitiesAdminControllerDeleteOneResponses,
  CitiesAdminControllerGetOneData,
  CitiesAdminControllerGetOneResponses,
  CitiesAdminControllerListData,
  CitiesAdminControllerListResponses,
  CitiesAdminControllerUpdateOneData,
  CitiesAdminControllerUpdateOneResponses,
  CitiesControllerCreateData,
  CitiesControllerCreateResponses,
  CitiesControllerFindAllData,
  CitiesControllerFindAllResponses,
  CitiesControllerFindOneData,
  CitiesControllerFindOneResponses,
  CitiesControllerRemoveData,
  CitiesControllerRemoveResponses,
  CitiesControllerUpdateData,
  CitiesControllerUpdateResponses,
  CryptorsAdminControllerCreateManyData,
  CryptorsAdminControllerCreateManyResponses,
  CryptorsAdminControllerCreateOneData,
  CryptorsAdminControllerCreateOneResponses,
  CryptorsAdminControllerDeleteOneData,
  CryptorsAdminControllerDeleteOneResponses,
  CryptorsAdminControllerGenerateCaptureLinkData,
  CryptorsAdminControllerGenerateCaptureLinkResponses,
  CryptorsAdminControllerGetOneData,
  CryptorsAdminControllerGetOneResponses,
  CryptorsAdminControllerListData,
  CryptorsAdminControllerListResponses,
  CryptorsAdminControllerUpdateOneData,
  CryptorsAdminControllerUpdateOneResponses,
  CryptorsControllerCaptureByLinkData,
  CryptorsControllerCaptureByLinkResponses,
  CryptorsControllerCaptureRedirectData,
  CryptorsControllerCaptureRedirectResponses,
  CryptorsControllerCreateData,
  CryptorsControllerCreateResponses,
  CryptorsControllerFindAllCollectionData,
  CryptorsControllerFindAllCollectionResponses,
  CryptorsControllerFindAllData,
  CryptorsControllerFindAllMapData,
  CryptorsControllerFindAllMapResponses,
  CryptorsControllerFindAllResponses,
  CryptorsControllerFindOneData,
  CryptorsControllerFindOneResponses,
  CryptorsControllerFoundCryptorData,
  CryptorsControllerFoundCryptorResponses,
  CryptorsControllerFoundCryptorTutorialData,
  CryptorsControllerFoundCryptorTutorialResponses,
  CryptorsControllerGetQuizData,
  CryptorsControllerGetQuizResponses,
  CryptorsControllerGetQuizScoreData,
  CryptorsControllerGetQuizScoreResponses,
  CryptorsControllerRemoveData,
  CryptorsControllerRemoveResponses,
  CryptorsControllerUpdateData,
  CryptorsControllerUpdateResponses,
  FaqAdminControllerCreateManyData,
  FaqAdminControllerCreateManyResponses,
  FaqAdminControllerCreateOneData,
  FaqAdminControllerCreateOneResponses,
  FaqAdminControllerDeleteOneData,
  FaqAdminControllerDeleteOneResponses,
  FaqAdminControllerGetOneData,
  FaqAdminControllerGetOneResponses,
  FaqAdminControllerListData,
  FaqAdminControllerListResponses,
  FaqAdminControllerUpdateOneData,
  FaqAdminControllerUpdateOneResponses,
  FaqControllerCreateData,
  FaqControllerCreateResponses,
  FaqControllerFindAllData,
  FaqControllerFindAllResponses,
  FaqControllerFindOneData,
  FaqControllerFindOneResponses,
  FaqControllerRemoveData,
  FaqControllerRemoveResponses,
  FaqControllerSendFeedbackData,
  FaqControllerSendFeedbackResponses,
  FaqControllerUpdateData,
  FaqControllerUpdateResponses,
  HintControllerCreateData,
  HintControllerCreateResponses,
  HintControllerFindAllData,
  HintControllerFindAllResponses,
  HintControllerFindOneData,
  HintControllerFindOneResponses,
  HintControllerRemoveData,
  HintControllerRemoveResponses,
  HintControllerRequestHintData,
  HintControllerRequestHintResponses,
  HintControllerUpdateData,
  HintControllerUpdateResponses,
  HintsAdminControllerCreateManyData,
  HintsAdminControllerCreateManyResponses,
  HintsAdminControllerCreateOneData,
  HintsAdminControllerCreateOneResponses,
  HintsAdminControllerDeleteOneData,
  HintsAdminControllerDeleteOneResponses,
  HintsAdminControllerGetOneData,
  HintsAdminControllerGetOneResponses,
  HintsAdminControllerListData,
  HintsAdminControllerListResponses,
  HintsAdminControllerUpdateOneData,
  HintsAdminControllerUpdateOneResponses,
  LevelsAdminControllerCreateManyData,
  LevelsAdminControllerCreateManyResponses,
  LevelsAdminControllerCreateOneData,
  LevelsAdminControllerCreateOneResponses,
  LevelsAdminControllerDeleteOneData,
  LevelsAdminControllerDeleteOneResponses,
  LevelsAdminControllerGetOneData,
  LevelsAdminControllerGetOneResponses,
  LevelsAdminControllerListData,
  LevelsAdminControllerListResponses,
  LevelsAdminControllerUpdateOneData,
  LevelsAdminControllerUpdateOneResponses,
  LevelsControllerCreateData,
  LevelsControllerCreateResponses,
  LevelsControllerFindAllData,
  LevelsControllerFindAllResponses,
  LevelsControllerFindOneData,
  LevelsControllerFindOneResponses,
  LevelsControllerRemoveData,
  LevelsControllerRemoveResponses,
  LevelsControllerUpdateData,
  LevelsControllerUpdateResponses,
  PredictionControllerReindexData,
  PredictionControllerReindexResponses,
  QuestionsAdminControllerCreateManyData,
  QuestionsAdminControllerCreateManyResponses,
  QuestionsAdminControllerCreateOneData,
  QuestionsAdminControllerCreateOneResponses,
  QuestionsAdminControllerDeleteOneData,
  QuestionsAdminControllerDeleteOneResponses,
  QuestionsAdminControllerGetOneData,
  QuestionsAdminControllerGetOneResponses,
  QuestionsAdminControllerListData,
  QuestionsAdminControllerListResponses,
  QuestionsAdminControllerUpdateOneData,
  QuestionsAdminControllerUpdateOneResponses,
  QuestionsControllerAnswerData,
  QuestionsControllerAnswerResponses,
  QuestionsControllerCreateData,
  QuestionsControllerCreateResponses,
  QuestionsControllerFindAllData,
  QuestionsControllerFindAllResponses,
  QuestionsControllerFindOneData,
  QuestionsControllerFindOneResponses,
  QuestionsControllerRemoveData,
  QuestionsControllerRemoveResponses,
  QuestionsControllerUpdateData,
  QuestionsControllerUpdateResponses,
  QuizAdminControllerCreateManyData,
  QuizAdminControllerCreateManyResponses,
  QuizAdminControllerCreateOneData,
  QuizAdminControllerCreateOneResponses,
  QuizAdminControllerDeleteOneData,
  QuizAdminControllerDeleteOneResponses,
  QuizAdminControllerGetOneData,
  QuizAdminControllerGetOneResponses,
  QuizAdminControllerListData,
  QuizAdminControllerListResponses,
  QuizAdminControllerUpdateOneData,
  QuizAdminControllerUpdateOneResponses,
  QuizControllerAnswerData,
  QuizControllerAnswerResponses,
  QuizControllerCreateQuizData,
  QuizControllerCreateQuizResponses,
  QuizControllerCreateQuizTakeData,
  QuizControllerCreateQuizTakeResponses,
  QuizControllerDeleteQuizData,
  QuizControllerDeleteQuizResponses,
  QuizControllerGetQuizTakeData,
  QuizControllerGetQuizTakeResponses,
  QuizControllerUpdateQuizData,
  QuizControllerUpdateQuizResponses,
  S3ControllerGetSignedUrlData,
  S3ControllerGetSignedUrlResponses,
  StatsAdminControllerClientCryptorsData,
  StatsAdminControllerClientCryptorsResponses,
  StatsAdminControllerCollectionsData,
  StatsAdminControllerCollectionsResponses,
  StatsAdminControllerComparisonData,
  StatsAdminControllerComparisonResponses,
  StatsAdminControllerNetworkData,
  StatsAdminControllerNetworkResponses,
  StatsAdminControllerPeriodData,
  StatsAdminControllerPeriodResponses,
  StatsAdminControllerQrsData,
  StatsAdminControllerQrsResponses,
  StatsAdminControllerSnapshotData,
  StatsAdminControllerSnapshotResponses,
  TranslationAdminControllerCreateManyData,
  TranslationAdminControllerCreateManyResponses,
  TranslationAdminControllerCreateOneData,
  TranslationAdminControllerCreateOneResponses,
  TranslationAdminControllerDeleteOneData,
  TranslationAdminControllerDeleteOneResponses,
  TranslationAdminControllerGetOneData,
  TranslationAdminControllerGetOneResponses,
  TranslationAdminControllerListData,
  TranslationAdminControllerListResponses,
  TranslationAdminControllerUpdateOneData,
  TranslationAdminControllerUpdateOneResponses,
  TranslationControllerFindAllData,
  TranslationControllerFindAllResponses,
  TranslationControllerGenerateMissingKeysData,
  TranslationControllerGenerateMissingKeysResponses,
  TranslationControllerUpdateTranslationData,
  TranslationControllerUpdateTranslationResponses,
  UsersAdminControllerCreateManyData,
  UsersAdminControllerCreateManyResponses,
  UsersAdminControllerCreateOneData,
  UsersAdminControllerCreateOneResponses,
  UsersAdminControllerDeleteOneData,
  UsersAdminControllerDeleteOneResponses,
  UsersAdminControllerGetOneData,
  UsersAdminControllerGetOneResponses,
  UsersAdminControllerListData,
  UsersAdminControllerListResponses,
  UsersAdminControllerUpdateOneData,
  UsersAdminControllerUpdateOneResponses,
  UsersControllerCreateUserData,
  UsersControllerCreateUserResponses,
  UsersControllerDeleteAccountData,
  UsersControllerDeleteAccountResponses,
  UsersControllerDeleteUserData,
  UsersControllerDeleteUserResponses,
  UsersControllerGetAllUsersData,
  UsersControllerGetAllUsersResponses,
  UsersControllerGetUserData,
  UsersControllerGetUserResponses,
  UsersControllerLeaderboardData,
  UsersControllerLeaderboardResponses,
  UsersControllerMeData,
  UsersControllerMeResponses,
  UsersControllerUpdateMeData,
  UsersControllerUpdateMeResponses,
  UsersControllerUpdateUserData,
  UsersControllerUpdateUserResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const appControllerStore = <ThrowOnError extends boolean = false>(
  options?: Options<AppControllerStoreData, ThrowOnError>,
): RequestResult<unknown, unknown, ThrowOnError> =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: "/app-store",
    ...options,
  });

export const appControllerGetMinAppVersion = <ThrowOnError extends boolean = false>(
  options?: Options<AppControllerGetMinAppVersionData, ThrowOnError>,
): RequestResult<AppControllerGetMinAppVersionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AppControllerGetMinAppVersionResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/min-app-version",
    ...options,
  });

export const translationControllerFindAll = <ThrowOnError extends boolean = false>(
  options: Options<TranslationControllerFindAllData, ThrowOnError>,
): RequestResult<TranslationControllerFindAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<TranslationControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/translation",
    ...options,
  });

export const translationControllerUpdateTranslation = <ThrowOnError extends boolean = false>(
  options: Options<TranslationControllerUpdateTranslationData, ThrowOnError>,
): RequestResult<TranslationControllerUpdateTranslationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    TranslationControllerUpdateTranslationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/translation/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const translationControllerGenerateMissingKeys = <ThrowOnError extends boolean = false>(
  options?: Options<TranslationControllerGenerateMissingKeysData, ThrowOnError>,
): RequestResult<TranslationControllerGenerateMissingKeysResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    TranslationControllerGenerateMissingKeysResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/translation/generate-missing-keys",
    ...options,
  });

export const translationAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<TranslationAdminControllerListData, ThrowOnError>,
): RequestResult<TranslationAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<TranslationAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/translation",
    ...options,
  });

export const translationAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<TranslationAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<TranslationAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    TranslationAdminControllerCreateOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/translation",
    ...options,
  });

export const translationAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<TranslationAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<TranslationAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    TranslationAdminControllerDeleteOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/translation/{id}",
    ...options,
  });

export const translationAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<TranslationAdminControllerGetOneData, ThrowOnError>,
): RequestResult<TranslationAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<TranslationAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/translation/{id}",
    ...options,
  });

export const translationAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<TranslationAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<TranslationAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    TranslationAdminControllerUpdateOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/translation/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const translationAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<TranslationAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<TranslationAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    TranslationAdminControllerCreateManyResponses,
    unknown,
    ThrowOnError
  >({ url: "/admin/translation/bulk", ...options });

export const s3ControllerGetSignedUrl = <ThrowOnError extends boolean = false>(
  options: Options<S3ControllerGetSignedUrlData, ThrowOnError>,
): RequestResult<S3ControllerGetSignedUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<S3ControllerGetSignedUrlResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/s3/put-signed-url",
    ...options,
  });

export const avatarsControllerFindAllAuthenticated = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarsControllerFindAllAuthenticatedData, ThrowOnError>,
): RequestResult<AvatarsControllerFindAllAuthenticatedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AvatarsControllerFindAllAuthenticatedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/avatars/owned",
    ...options,
  });

export const avatarsControllerFindAllUnAuthenticated = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarsControllerFindAllUnAuthenticatedData, ThrowOnError>,
): RequestResult<AvatarsControllerFindAllUnAuthenticatedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AvatarsControllerFindAllUnAuthenticatedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/avatars",
    ...options,
  });

export const avatarsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsControllerCreateData, ThrowOnError>,
): RequestResult<AvatarsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AvatarsControllerCreateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/avatars",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const avatarsControllerFindMyAvatar = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarsControllerFindMyAvatarData, ThrowOnError>,
): RequestResult<AvatarsControllerFindMyAvatarResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AvatarsControllerFindMyAvatarResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/avatars/me",
    ...options,
  });

export const avatarsControllerUpdateMyAvatar = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsControllerUpdateMyAvatarData, ThrowOnError>,
): RequestResult<AvatarsControllerUpdateMyAvatarResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<AvatarsControllerUpdateMyAvatarResponses, unknown, ThrowOnError>({
    url: "/avatars/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const avatarsControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsControllerRemoveData, ThrowOnError>,
): RequestResult<AvatarsControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<AvatarsControllerRemoveResponses, unknown, ThrowOnError>({
    url: "/avatars/{id}",
    ...options,
  });

export const avatarsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsControllerFindOneData, ThrowOnError>,
): RequestResult<AvatarsControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<AvatarsControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/avatars/{id}",
    ...options,
  });

export const avatarsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsControllerUpdateData, ThrowOnError>,
): RequestResult<AvatarsControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<AvatarsControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/avatars/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const avatarsAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarsAdminControllerListData, ThrowOnError>,
): RequestResult<AvatarsAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AvatarsAdminControllerListResponses, unknown, ThrowOnError>({
    url: "/admin/avatars",
    ...options,
  });

export const avatarsAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarsAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<AvatarsAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AvatarsAdminControllerCreateOneResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      url: "/admin/avatars",
      ...options,
    },
  );

export const avatarsAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<AvatarsAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AvatarsAdminControllerDeleteOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/avatars/{id}",
    ...options,
  });

export const avatarsAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsAdminControllerGetOneData, ThrowOnError>,
): RequestResult<AvatarsAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<AvatarsAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/avatars/{id}",
    ...options,
  });

export const avatarsAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<AvatarsAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<AvatarsAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<AvatarsAdminControllerUpdateOneResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      url: "/admin/avatars/{id}",
      ...options,
    },
  );

export const avatarsAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarsAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<AvatarsAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    AvatarsAdminControllerCreateManyResponses,
    unknown,
    ThrowOnError
  >({ url: "/admin/avatars/bulk", ...options });

export const usersControllerLeaderboard = <ThrowOnError extends boolean = false>(
  options?: Options<UsersControllerLeaderboardData, ThrowOnError>,
): RequestResult<UsersControllerLeaderboardResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersControllerLeaderboardResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/users/leaderboard",
    ...options,
  });

export const usersControllerDeleteAccount = <ThrowOnError extends boolean = false>(
  options?: Options<UsersControllerDeleteAccountData, ThrowOnError>,
): RequestResult<UsersControllerDeleteAccountResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).delete<UsersControllerDeleteAccountResponses, unknown, ThrowOnError>({
    url: "/users/me",
    ...options,
  });

export const usersControllerMe = <ThrowOnError extends boolean = false>(
  options?: Options<UsersControllerMeData, ThrowOnError>,
): RequestResult<UsersControllerMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersControllerMeResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/users/me",
    ...options,
  });

export const usersControllerUpdateMe = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerUpdateMeData, ThrowOnError>,
): RequestResult<UsersControllerUpdateMeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UsersControllerUpdateMeResponses, unknown, ThrowOnError>({
    url: "/users/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const usersControllerDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerDeleteUserData, ThrowOnError>,
): RequestResult<UsersControllerDeleteUserResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<UsersControllerDeleteUserResponses, unknown, ThrowOnError>({
    url: "/users/{id}",
    ...options,
  });

export const usersControllerGetUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerGetUserData, ThrowOnError>,
): RequestResult<UsersControllerGetUserResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UsersControllerGetUserResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/users/{id}",
    ...options,
  });

export const usersControllerUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerUpdateUserData, ThrowOnError>,
): RequestResult<UsersControllerUpdateUserResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<UsersControllerUpdateUserResponses, unknown, ThrowOnError>({
    url: "/users/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const usersControllerGetAllUsers = <ThrowOnError extends boolean = false>(
  options?: Options<UsersControllerGetAllUsersData, ThrowOnError>,
): RequestResult<UsersControllerGetAllUsersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersControllerGetAllUsersResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/users",
    ...options,
  });

export const usersControllerCreateUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerCreateUserData, ThrowOnError>,
): RequestResult<UsersControllerCreateUserResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UsersControllerCreateUserResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const usersAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminControllerListData, ThrowOnError>,
): RequestResult<UsersAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/users",
    ...options,
  });

export const usersAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<UsersAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UsersAdminControllerCreateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const usersAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<UsersAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<UsersAdminControllerDeleteOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/users/{id}",
    ...options,
  });

export const usersAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminControllerGetOneData, ThrowOnError>,
): RequestResult<UsersAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UsersAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/users/{id}",
    ...options,
  });

export const usersAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<UsersAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<UsersAdminControllerUpdateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/users/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const usersAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<UsersAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<UsersAdminControllerCreateManyResponses, unknown, ThrowOnError>({
    url: "/admin/users/bulk",
    ...options,
  });

export const authControllerLogin = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerLoginData, ThrowOnError>,
): RequestResult<AuthControllerLoginResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthControllerLoginResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/auth/login",
    ...options,
  });

export const authControllerAnonymousLogin = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerAnonymousLoginData, ThrowOnError>,
): RequestResult<AuthControllerAnonymousLoginResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthControllerAnonymousLoginResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/auth/anonymous-login",
    ...options,
  });

export const authControllerRegister = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerRegisterData, ThrowOnError>,
): RequestResult<AuthControllerRegisterResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AuthControllerRegisterResponses, unknown, ThrowOnError>({
    url: "/auth/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerMe = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerMeData, ThrowOnError>,
): RequestResult<AuthControllerMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AuthControllerMeResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/auth/me",
    ...options,
  });

export const authControllerVerifyEmail = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerVerifyEmailData, ThrowOnError>,
): RequestResult<AuthControllerVerifyEmailResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<AuthControllerVerifyEmailResponses, unknown, ThrowOnError>({
    url: "/auth/verify-email/{token}",
    ...options,
  });

export const authControllerCheckEmailAvailability = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerCheckEmailAvailabilityData, ThrowOnError>,
): RequestResult<AuthControllerCheckEmailAvailabilityResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    AuthControllerCheckEmailAvailabilityResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/check-email-availability",
    ...options,
  });

export const authControllerCheckPseudoAvailability = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerCheckPseudoAvailabilityData, ThrowOnError>,
): RequestResult<AuthControllerCheckPseudoAvailabilityResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    AuthControllerCheckPseudoAvailabilityResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/check-pseudo-availability",
    ...options,
  });

export const authControllerResendVerificationEmail = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerResendVerificationEmailData, ThrowOnError>,
): RequestResult<AuthControllerResendVerificationEmailResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    AuthControllerResendVerificationEmailResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/resend-verification-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerForgotPassword = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerForgotPasswordData, ThrowOnError>,
): RequestResult<AuthControllerForgotPasswordResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AuthControllerForgotPasswordResponses, unknown, ThrowOnError>({
    url: "/auth/request-password-reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerResetPasswordCodeCheck = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerResetPasswordCodeCheckData, ThrowOnError>,
): RequestResult<AuthControllerResetPasswordCodeCheckResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    AuthControllerResetPasswordCodeCheckResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/reset-password-code-check",
    ...options,
  });

export const authControllerResetPassword = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerResetPasswordData, ThrowOnError>,
): RequestResult<AuthControllerResetPasswordResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AuthControllerResetPasswordResponses, unknown, ThrowOnError>({
    url: "/auth/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerChangePassword = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerChangePasswordData, ThrowOnError>,
): RequestResult<AuthControllerChangePasswordResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AuthControllerChangePasswordResponses, unknown, ThrowOnError>({
    url: "/auth/change-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerChangeEmail = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerChangeEmailData, ThrowOnError>,
): RequestResult<AuthControllerChangeEmailResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AuthControllerChangeEmailResponses, unknown, ThrowOnError>({
    url: "/auth/request-change-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerRequestSetEmail = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerRequestSetEmailData, ThrowOnError>,
): RequestResult<AuthControllerRequestSetEmailResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AuthControllerRequestSetEmailResponses, unknown, ThrowOnError>({
    url: "/auth/request-set-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerVerifyChangeEmail = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerVerifyChangeEmailData, ThrowOnError>,
): RequestResult<AuthControllerVerifyChangeEmailResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<AuthControllerVerifyChangeEmailResponses, unknown, ThrowOnError>({
    url: "/auth/verify-change-email/{token}",
    ...options,
  });

export const authControllerFillLoginDetails = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerFillLoginDetailsData, ThrowOnError>,
): RequestResult<AuthControllerFillLoginDetailsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<AuthControllerFillLoginDetailsResponses, unknown, ThrowOnError>({
    url: "/auth/fill-login-details",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const citiesControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<CitiesControllerFindAllData, ThrowOnError>,
): RequestResult<CitiesControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CitiesControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cities",
    ...options,
  });

export const citiesControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CitiesControllerCreateData, ThrowOnError>,
): RequestResult<CitiesControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CitiesControllerCreateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cities",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const citiesControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<CitiesControllerRemoveData, ThrowOnError>,
): RequestResult<CitiesControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CitiesControllerRemoveResponses, unknown, ThrowOnError>({
    url: "/cities/{id}",
    ...options,
  });

export const citiesControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<CitiesControllerFindOneData, ThrowOnError>,
): RequestResult<CitiesControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CitiesControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cities/{id}",
    ...options,
  });

export const citiesControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CitiesControllerUpdateData, ThrowOnError>,
): RequestResult<CitiesControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<CitiesControllerUpdateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cities/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const citiesAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<CitiesAdminControllerListData, ThrowOnError>,
): RequestResult<CitiesAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CitiesAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/cities",
    ...options,
  });

export const citiesAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<CitiesAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<CitiesAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CitiesAdminControllerCreateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/cities",
    ...options,
  });

export const citiesAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<CitiesAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<CitiesAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CitiesAdminControllerDeleteOneResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      url: "/admin/cities/{id}",
      ...options,
    },
  );

export const citiesAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<CitiesAdminControllerGetOneData, ThrowOnError>,
): RequestResult<CitiesAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CitiesAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/cities/{id}",
    ...options,
  });

export const citiesAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<CitiesAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<CitiesAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<CitiesAdminControllerUpdateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/cities/{id}",
    ...options,
  });

export const citiesAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<CitiesAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<CitiesAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CitiesAdminControllerCreateManyResponses, unknown, ThrowOnError>(
    { url: "/admin/cities/bulk", ...options },
  );

export const cryptorsControllerFoundCryptor = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerFoundCryptorData, ThrowOnError>,
): RequestResult<CryptorsControllerFoundCryptorResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CryptorsControllerFoundCryptorResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: "json",
    url: "/cryptors/scan",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

export const cryptorsControllerCaptureRedirect = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerCaptureRedirectData, ThrowOnError>,
): RequestResult<CryptorsControllerCaptureRedirectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CryptorsControllerCaptureRedirectResponses, unknown, ThrowOnError>(
    { url: "/capture", ...options },
  );

export const cryptorsControllerCaptureByLink = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerCaptureByLinkData, ThrowOnError>,
): RequestResult<CryptorsControllerCaptureByLinkResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CryptorsControllerCaptureByLinkResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors/capture-by-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cryptorsControllerFoundCryptorTutorial = <ThrowOnError extends boolean = false>(
  options?: Options<CryptorsControllerFoundCryptorTutorialData, ThrowOnError>,
): RequestResult<CryptorsControllerFoundCryptorTutorialResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    CryptorsControllerFoundCryptorTutorialResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/cryptors/scan-tutorial",
    ...options,
  });

export const cryptorsControllerFindAllCollection = <ThrowOnError extends boolean = false>(
  options?: Options<CryptorsControllerFindAllCollectionData, ThrowOnError>,
): RequestResult<CryptorsControllerFindAllCollectionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    CryptorsControllerFindAllCollectionResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/cryptors-collection",
    ...options,
  });

export const cryptorsControllerFindAllMap = <ThrowOnError extends boolean = false>(
  options?: Options<CryptorsControllerFindAllMapData, ThrowOnError>,
): RequestResult<CryptorsControllerFindAllMapResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CryptorsControllerFindAllMapResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors-map",
    ...options,
  });

export const cryptorsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<CryptorsControllerFindAllData, ThrowOnError>,
): RequestResult<CryptorsControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CryptorsControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors",
    ...options,
  });

export const cryptorsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerCreateData, ThrowOnError>,
): RequestResult<CryptorsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CryptorsControllerCreateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cryptorsControllerGetQuizScore = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerGetQuizScoreData, ThrowOnError>,
): RequestResult<CryptorsControllerGetQuizScoreResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CryptorsControllerGetQuizScoreResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors/{id}/is-ai-authorized",
    ...options,
  });

export const cryptorsControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerRemoveData, ThrowOnError>,
): RequestResult<CryptorsControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CryptorsControllerRemoveResponses, unknown, ThrowOnError>({
    url: "/cryptors/{id}",
    ...options,
  });

export const cryptorsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerFindOneData, ThrowOnError>,
): RequestResult<CryptorsControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CryptorsControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors/{id}",
    ...options,
  });

export const cryptorsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerUpdateData, ThrowOnError>,
): RequestResult<CryptorsControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<CryptorsControllerUpdateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cryptorsControllerGetQuiz = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsControllerGetQuizData, ThrowOnError>,
): RequestResult<CryptorsControllerGetQuizResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CryptorsControllerGetQuizResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/cryptors/{id}/quiz",
    ...options,
  });

export const cryptorsAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<CryptorsAdminControllerListData, ThrowOnError>,
): RequestResult<CryptorsAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CryptorsAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/cryptors",
    ...options,
  });

export const cryptorsAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<CryptorsAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CryptorsAdminControllerCreateOneResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      url: "/admin/cryptors",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

export const cryptorsAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<CryptorsAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    CryptorsAdminControllerDeleteOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/cryptors/{id}",
    ...options,
  });

export const cryptorsAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsAdminControllerGetOneData, ThrowOnError>,
): RequestResult<CryptorsAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CryptorsAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/cryptors/{id}",
    ...options,
  });

export const cryptorsAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<CryptorsAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    CryptorsAdminControllerUpdateOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/cryptors/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cryptorsAdminControllerGenerateCaptureLink = <ThrowOnError extends boolean = false>(
  options: Options<CryptorsAdminControllerGenerateCaptureLinkData, ThrowOnError>,
): RequestResult<CryptorsAdminControllerGenerateCaptureLinkResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    CryptorsAdminControllerGenerateCaptureLinkResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/cryptors/{id}/capture-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cryptorsAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<CryptorsAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<CryptorsAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    CryptorsAdminControllerCreateManyResponses,
    unknown,
    ThrowOnError
  >({ url: "/admin/cryptors/bulk", ...options });

export const faqControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<FaqControllerFindAllData, ThrowOnError>,
): RequestResult<FaqControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<FaqControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/faq",
    ...options,
  });

export const faqControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerCreateData, ThrowOnError>,
): RequestResult<FaqControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FaqControllerCreateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/faq",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const faqControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerRemoveData, ThrowOnError>,
): RequestResult<FaqControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<FaqControllerRemoveResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/faq/{id}",
    ...options,
  });

export const faqControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerFindOneData, ThrowOnError>,
): RequestResult<FaqControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FaqControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/faq/{id}",
    ...options,
  });

export const faqControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerUpdateData, ThrowOnError>,
): RequestResult<FaqControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<FaqControllerUpdateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/faq/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const faqAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<FaqAdminControllerListData, ThrowOnError>,
): RequestResult<FaqAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<FaqAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/faq",
    ...options,
  });

export const faqAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<FaqAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<FaqAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<FaqAdminControllerCreateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/faq",
    ...options,
  });

export const faqAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<FaqAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<FaqAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<FaqAdminControllerDeleteOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/faq/{id}",
    ...options,
  });

export const faqAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<FaqAdminControllerGetOneData, ThrowOnError>,
): RequestResult<FaqAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FaqAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/faq/{id}",
    ...options,
  });

export const faqAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<FaqAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<FaqAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<FaqAdminControllerUpdateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/faq/{id}",
    ...options,
  });

export const faqAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<FaqAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<FaqAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<FaqAdminControllerCreateManyResponses, unknown, ThrowOnError>({
    url: "/admin/faq/bulk",
    ...options,
  });

export const chatControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<ChatControllerFindAllData, ThrowOnError>,
): RequestResult<ChatControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ChatControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/chat",
    ...options,
  });

export const chatControllerGetCryptorChat = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerGetCryptorChatData, ThrowOnError>,
): RequestResult<ChatControllerGetCryptorChatResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ChatControllerGetCryptorChatResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/chat/me/cryptor/{cryptorId}",
    ...options,
  });

export const chatControllerAnswerQuestion = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerAnswerQuestionData, ThrowOnError>,
): RequestResult<ChatControllerAnswerQuestionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ChatControllerAnswerQuestionResponses, unknown, ThrowOnError>({
    url: "/chat/answer/{chatQuestionUserId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const chatControllerRegenerateMessage = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerRegenerateMessageData, ThrowOnError>,
): RequestResult<ChatControllerRegenerateMessageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ChatControllerRegenerateMessageResponses, unknown, ThrowOnError>({
    url: "/chat/cryptor/{cryptorId}/chat/regenerate",
    ...options,
  });

export const chatControllerGetCryptorChatMessages = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerGetCryptorChatMessagesData, ThrowOnError>,
): RequestResult<ChatControllerGetCryptorChatMessagesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    ChatControllerGetCryptorChatMessagesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/chat/cryptors/{cryptorId}/chat-message",
    ...options,
  });

export const chatControllerCreateChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerCreateChatMessageData, ThrowOnError>,
): RequestResult<ChatControllerCreateChatMessageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ChatControllerCreateChatMessageResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/chat/cryptors/{cryptorId}/chat-message",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const chatControllerDeleteChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerDeleteChatMessageData, ThrowOnError>,
): RequestResult<ChatControllerDeleteChatMessageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    ChatControllerDeleteChatMessageResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/chat/cryptors/{cryptorId}/chat-message/{id}",
    ...options,
  });

export const chatControllerGetCryptorChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerGetCryptorChatMessageData, ThrowOnError>,
): RequestResult<ChatControllerGetCryptorChatMessageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    ChatControllerGetCryptorChatMessageResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/chat/cryptors/{cryptorId}/chat-message/{id}",
    ...options,
  });

export const chatControllerEditChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<ChatControllerEditChatMessageData, ThrowOnError>,
): RequestResult<ChatControllerEditChatMessageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ChatControllerEditChatMessageResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/chat/cryptors/{cryptorId}/chat-message/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const chatMessageAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<ChatMessageAdminControllerListData, ThrowOnError>,
): RequestResult<ChatMessageAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ChatMessageAdminControllerListResponses, unknown, ThrowOnError>({
    url: "/admin/chat-message",
    ...options,
  });

export const chatMessageAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<ChatMessageAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<ChatMessageAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    ChatMessageAdminControllerCreateOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/chat-message",
    ...options,
  });

export const chatMessageAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<ChatMessageAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<ChatMessageAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    ChatMessageAdminControllerDeleteOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/chat-message/{id}",
    ...options,
  });

export const chatMessageAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<ChatMessageAdminControllerGetOneData, ThrowOnError>,
): RequestResult<ChatMessageAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ChatMessageAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/chat-message/{id}",
    ...options,
  });

export const chatMessageAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<ChatMessageAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<ChatMessageAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    ChatMessageAdminControllerUpdateOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/chat-message/{id}",
    ...options,
  });

export const chatMessageAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<ChatMessageAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<ChatMessageAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    ChatMessageAdminControllerCreateManyResponses,
    unknown,
    ThrowOnError
  >({ url: "/admin/chat-message/bulk", ...options });

export const levelsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<LevelsControllerFindAllData, ThrowOnError>,
): RequestResult<LevelsControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<LevelsControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/levels",
    ...options,
  });

export const levelsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<LevelsControllerCreateData, ThrowOnError>,
): RequestResult<LevelsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<LevelsControllerCreateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/levels",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const levelsControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<LevelsControllerRemoveData, ThrowOnError>,
): RequestResult<LevelsControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<LevelsControllerRemoveResponses, unknown, ThrowOnError>({
    url: "/levels/{level}",
    ...options,
  });

export const levelsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<LevelsControllerFindOneData, ThrowOnError>,
): RequestResult<LevelsControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<LevelsControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/levels/{level}",
    ...options,
  });

export const levelsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LevelsControllerUpdateData, ThrowOnError>,
): RequestResult<LevelsControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<LevelsControllerUpdateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/levels/{level}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const levelsAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<LevelsAdminControllerListData, ThrowOnError>,
): RequestResult<LevelsAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<LevelsAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/levels",
    ...options,
  });

export const levelsAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<LevelsAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<LevelsAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LevelsAdminControllerCreateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/levels",
    ...options,
  });

export const levelsAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<LevelsAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<LevelsAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<LevelsAdminControllerDeleteOneResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      url: "/admin/levels/{id}",
      ...options,
    },
  );

export const levelsAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<LevelsAdminControllerGetOneData, ThrowOnError>,
): RequestResult<LevelsAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<LevelsAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/levels/{id}",
    ...options,
  });

export const levelsAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<LevelsAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<LevelsAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<LevelsAdminControllerUpdateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/levels/{id}",
    ...options,
  });

export const levelsAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<LevelsAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<LevelsAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LevelsAdminControllerCreateManyResponses, unknown, ThrowOnError>(
    { url: "/admin/levels/bulk", ...options },
  );

export const chatgptControllerGetCryptorChatGpt = <ThrowOnError extends boolean = false>(
  options: Options<ChatgptControllerGetCryptorChatGptData, ThrowOnError>,
): RequestResult<ChatgptControllerGetCryptorChatGptResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    ChatgptControllerGetCryptorChatGptResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/chatgpt/me/cryptor/{cryptorId}",
    ...options,
  });

export const chatgptControllerCollectQuestion = <ThrowOnError extends boolean = false>(
  options: Options<ChatgptControllerCollectQuestionData, ThrowOnError>,
): RequestResult<ChatgptControllerCollectQuestionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ChatgptControllerCollectQuestionResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      url: "/chatgpt/me/cryptor/{cryptorId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

export const advertisementsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<AdvertisementsControllerFindAllData, ThrowOnError>,
): RequestResult<AdvertisementsControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdvertisementsControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/advertisements",
    ...options,
  });

export const advertisementsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsControllerCreateData, ThrowOnError>,
): RequestResult<AdvertisementsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AdvertisementsControllerCreateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/advertisements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const advertisementsControllerRecordView = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsControllerRecordViewData, ThrowOnError>,
): RequestResult<AdvertisementsControllerRecordViewResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    AdvertisementsControllerRecordViewResponses,
    unknown,
    ThrowOnError
  >({
    url: "/advertisements/views",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const advertisementsControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsControllerRemoveData, ThrowOnError>,
): RequestResult<AdvertisementsControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<AdvertisementsControllerRemoveResponses, unknown, ThrowOnError>(
    { url: "/advertisements/{id}", ...options },
  );

export const advertisementsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsControllerFindOneData, ThrowOnError>,
): RequestResult<AdvertisementsControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<AdvertisementsControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/advertisements/{id}",
    ...options,
  });

export const advertisementsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsControllerUpdateData, ThrowOnError>,
): RequestResult<AdvertisementsControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<AdvertisementsControllerUpdateResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/advertisements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const advertisementsAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<AdvertisementsAdminControllerListData, ThrowOnError>,
): RequestResult<AdvertisementsAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AdvertisementsAdminControllerListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/advertisements",
    ...options,
  });

export const advertisementsAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<AdvertisementsAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<AdvertisementsAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    AdvertisementsAdminControllerCreateOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/advertisements",
    ...options,
  });

export const advertisementsAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<AdvertisementsAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AdvertisementsAdminControllerDeleteOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/advertisements/{id}",
    ...options,
  });

export const advertisementsAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsAdminControllerGetOneData, ThrowOnError>,
): RequestResult<AdvertisementsAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    AdvertisementsAdminControllerGetOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/advertisements/{id}",
    ...options,
  });

export const advertisementsAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<AdvertisementsAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<AdvertisementsAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    AdvertisementsAdminControllerUpdateOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/advertisements/{id}",
    ...options,
  });

export const advertisementsAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<AdvertisementsAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<AdvertisementsAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    AdvertisementsAdminControllerCreateManyResponses,
    unknown,
    ThrowOnError
  >({ url: "/admin/advertisements/bulk", ...options });

export const announcementsControllerFindActive = <ThrowOnError extends boolean = false>(
  options?: Options<AnnouncementsControllerFindActiveData, ThrowOnError>,
): RequestResult<AnnouncementsControllerFindActiveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AnnouncementsControllerFindActiveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/announcements",
    ...options,
  });

export const announcementsAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<AnnouncementsAdminControllerListData, ThrowOnError>,
): RequestResult<AnnouncementsAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AnnouncementsAdminControllerListResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      url: "/admin/announcements",
      ...options,
    },
  );

export const announcementsAdminControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<AnnouncementsAdminControllerCreateData, ThrowOnError>,
): RequestResult<AnnouncementsAdminControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    AnnouncementsAdminControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/announcements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const announcementsAdminControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<AnnouncementsAdminControllerRemoveData, ThrowOnError>,
): RequestResult<AnnouncementsAdminControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AnnouncementsAdminControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/announcements/{id}",
    ...options,
  });

export const announcementsAdminControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<AnnouncementsAdminControllerFindOneData, ThrowOnError>,
): RequestResult<AnnouncementsAdminControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    AnnouncementsAdminControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/announcements/{id}",
    ...options,
  });

export const announcementsAdminControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<AnnouncementsAdminControllerUpdateData, ThrowOnError>,
): RequestResult<AnnouncementsAdminControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    AnnouncementsAdminControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/announcements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const faqControllerSendFeedback = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerSendFeedbackData, ThrowOnError>,
): RequestResult<FaqControllerSendFeedbackResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FaqControllerSendFeedbackResponses, unknown, ThrowOnError>({
    url: "/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const hintControllerRequestHint = <ThrowOnError extends boolean = false>(
  options: Options<HintControllerRequestHintData, ThrowOnError>,
): RequestResult<HintControllerRequestHintResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<HintControllerRequestHintResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/hints/{id}/request",
    ...options,
  });

export const hintControllerFindAll = <ThrowOnError extends boolean = false>(
  options: Options<HintControllerFindAllData, ThrowOnError>,
): RequestResult<HintControllerFindAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<HintControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/hints",
    ...options,
  });

export const hintControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<HintControllerCreateData, ThrowOnError>,
): RequestResult<HintControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<HintControllerCreateResponses, unknown, ThrowOnError>({
    url: "/hints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const hintControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<HintControllerRemoveData, ThrowOnError>,
): RequestResult<HintControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<HintControllerRemoveResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/hints/{id}",
    ...options,
  });

export const hintControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<HintControllerFindOneData, ThrowOnError>,
): RequestResult<HintControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<HintControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/hints/{id}",
    ...options,
  });

export const hintControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<HintControllerUpdateData, ThrowOnError>,
): RequestResult<HintControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<HintControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/hints/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const hintsAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<HintsAdminControllerListData, ThrowOnError>,
): RequestResult<HintsAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<HintsAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/hints",
    ...options,
  });

export const hintsAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options: Options<HintsAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<HintsAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<HintsAdminControllerCreateOneResponses, unknown, ThrowOnError>({
    url: "/admin/hints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const hintsAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<HintsAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<HintsAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<HintsAdminControllerDeleteOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/hints/{id}",
    ...options,
  });

export const hintsAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<HintsAdminControllerGetOneData, ThrowOnError>,
): RequestResult<HintsAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<HintsAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/hints/{id}",
    ...options,
  });

export const hintsAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<HintsAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<HintsAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<HintsAdminControllerUpdateOneResponses, unknown, ThrowOnError>({
    url: "/admin/hints/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const hintsAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<HintsAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<HintsAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<HintsAdminControllerCreateManyResponses, unknown, ThrowOnError>({
    url: "/admin/hints/bulk",
    ...options,
  });

export const questionsControllerFindAll = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsControllerFindAllData, ThrowOnError>,
): RequestResult<QuestionsControllerFindAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<QuestionsControllerFindAllResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/questions",
    ...options,
  });

export const questionsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsControllerCreateData, ThrowOnError>,
): RequestResult<QuestionsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<QuestionsControllerCreateResponses, unknown, ThrowOnError>({
    url: "/questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const questionsControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsControllerRemoveData, ThrowOnError>,
): RequestResult<QuestionsControllerRemoveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<QuestionsControllerRemoveResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/questions/{id}",
    ...options,
  });

export const questionsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsControllerFindOneData, ThrowOnError>,
): RequestResult<QuestionsControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<QuestionsControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/questions/{id}",
    ...options,
  });

export const questionsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsControllerUpdateData, ThrowOnError>,
): RequestResult<QuestionsControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<QuestionsControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/questions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const questionsControllerAnswer = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsControllerAnswerData, ThrowOnError>,
): RequestResult<QuestionsControllerAnswerResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<QuestionsControllerAnswerResponses, unknown, ThrowOnError>({
    url: "/questions/{id}/answer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const questionsAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<QuestionsAdminControllerListData, ThrowOnError>,
): RequestResult<QuestionsAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<QuestionsAdminControllerListResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/questions",
    ...options,
  });

export const questionsAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<QuestionsAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    QuestionsAdminControllerCreateOneResponses,
    unknown,
    ThrowOnError
  >({
    url: "/admin/questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const questionsAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<QuestionsAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    QuestionsAdminControllerDeleteOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/questions/{id}",
    ...options,
  });

export const questionsAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsAdminControllerGetOneData, ThrowOnError>,
): RequestResult<QuestionsAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<QuestionsAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/questions/{id}",
    ...options,
  });

export const questionsAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<QuestionsAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<QuestionsAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    QuestionsAdminControllerUpdateOneResponses,
    unknown,
    ThrowOnError
  >({
    url: "/admin/questions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const questionsAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<QuestionsAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<QuestionsAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    QuestionsAdminControllerCreateManyResponses,
    unknown,
    ThrowOnError
  >({ url: "/admin/questions/bulk", ...options });

export const quizControllerCreateQuizTake = <ThrowOnError extends boolean = false>(
  options: Options<QuizControllerCreateQuizTakeData, ThrowOnError>,
): RequestResult<QuizControllerCreateQuizTakeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<QuizControllerCreateQuizTakeResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/quiz/{quizId}/take",
    ...options,
  });

export const quizControllerAnswer = <ThrowOnError extends boolean = false>(
  options: Options<QuizControllerAnswerData, ThrowOnError>,
): RequestResult<QuizControllerAnswerResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<QuizControllerAnswerResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/quiz/take/{quizTakeID}/proposition/{propositionId}/answer",
    ...options,
  });

export const quizControllerDeleteQuiz = <ThrowOnError extends boolean = false>(
  options: Options<QuizControllerDeleteQuizData, ThrowOnError>,
): RequestResult<QuizControllerDeleteQuizResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<QuizControllerDeleteQuizResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/quiz/{id}",
    ...options,
  });

export const quizControllerUpdateQuiz = <ThrowOnError extends boolean = false>(
  options: Options<QuizControllerUpdateQuizData, ThrowOnError>,
): RequestResult<QuizControllerUpdateQuizResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<QuizControllerUpdateQuizResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/quiz/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const quizControllerCreateQuiz = <ThrowOnError extends boolean = false>(
  options: Options<QuizControllerCreateQuizData, ThrowOnError>,
): RequestResult<QuizControllerCreateQuizResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<QuizControllerCreateQuizResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/quiz/{id}",
    ...options,
  });

export const quizControllerGetQuizTake = <ThrowOnError extends boolean = false>(
  options: Options<QuizControllerGetQuizTakeData, ThrowOnError>,
): RequestResult<QuizControllerGetQuizTakeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<QuizControllerGetQuizTakeResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/quiz/quiz-take/{id}",
    ...options,
  });

export const quizAdminControllerDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<QuizAdminControllerDeleteOneData, ThrowOnError>,
): RequestResult<QuizAdminControllerDeleteOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<QuizAdminControllerDeleteOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/quiz/{id}",
    ...options,
  });

export const quizAdminControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<QuizAdminControllerGetOneData, ThrowOnError>,
): RequestResult<QuizAdminControllerGetOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<QuizAdminControllerGetOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/quiz/{id}",
    ...options,
  });

export const quizAdminControllerUpdateOne = <ThrowOnError extends boolean = false>(
  options: Options<QuizAdminControllerUpdateOneData, ThrowOnError>,
): RequestResult<QuizAdminControllerUpdateOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<QuizAdminControllerUpdateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/quiz/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const quizAdminControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<QuizAdminControllerListData, ThrowOnError>,
): RequestResult<QuizAdminControllerListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<QuizAdminControllerListResponses, unknown, ThrowOnError>({
    url: "/admin/quiz",
    ...options,
  });

export const quizAdminControllerCreateOne = <ThrowOnError extends boolean = false>(
  options?: Options<QuizAdminControllerCreateOneData, ThrowOnError>,
): RequestResult<QuizAdminControllerCreateOneResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<QuizAdminControllerCreateOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/quiz",
    ...options,
  });

export const quizAdminControllerCreateMany = <ThrowOnError extends boolean = false>(
  options?: Options<QuizAdminControllerCreateManyData, ThrowOnError>,
): RequestResult<QuizAdminControllerCreateManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<QuizAdminControllerCreateManyResponses, unknown, ThrowOnError>({
    url: "/admin/quiz/bulk",
    ...options,
  });

export const artefactsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<ArtefactsControllerFindOneData, ThrowOnError>,
): RequestResult<ArtefactsControllerFindOneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ArtefactsControllerFindOneResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/artefacts/{id}",
    ...options,
  });

export const predictionControllerReindex = <ThrowOnError extends boolean = false>(
  options?: Options<PredictionControllerReindexData, ThrowOnError>,
): RequestResult<PredictionControllerReindexResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<PredictionControllerReindexResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/prediction/reindex",
    ...options,
  });

export const statsAdminControllerSnapshot = <ThrowOnError extends boolean = false>(
  options?: Options<StatsAdminControllerSnapshotData, ThrowOnError>,
): RequestResult<StatsAdminControllerSnapshotResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StatsAdminControllerSnapshotResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/stats/snapshot",
    ...options,
  });

export const statsAdminControllerNetwork = <ThrowOnError extends boolean = false>(
  options?: Options<StatsAdminControllerNetworkData, ThrowOnError>,
): RequestResult<StatsAdminControllerNetworkResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StatsAdminControllerNetworkResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/stats/network",
    ...options,
  });

export const statsAdminControllerCollections = <ThrowOnError extends boolean = false>(
  options?: Options<StatsAdminControllerCollectionsData, ThrowOnError>,
): RequestResult<StatsAdminControllerCollectionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StatsAdminControllerCollectionsResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/stats/collections",
    ...options,
  });

export const statsAdminControllerClientCryptors = <ThrowOnError extends boolean = false>(
  options?: Options<StatsAdminControllerClientCryptorsData, ThrowOnError>,
): RequestResult<StatsAdminControllerClientCryptorsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    StatsAdminControllerClientCryptorsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/admin/stats/client-cryptors",
    ...options,
  });

export const statsAdminControllerQrs = <ThrowOnError extends boolean = false>(
  options?: Options<StatsAdminControllerQrsData, ThrowOnError>,
): RequestResult<StatsAdminControllerQrsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StatsAdminControllerQrsResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/stats/qrs",
    ...options,
  });

export const statsAdminControllerComparison = <ThrowOnError extends boolean = false>(
  options?: Options<StatsAdminControllerComparisonData, ThrowOnError>,
): RequestResult<StatsAdminControllerComparisonResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StatsAdminControllerComparisonResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/stats/comparison",
    ...options,
  });

export const statsAdminControllerPeriod = <ThrowOnError extends boolean = false>(
  options?: Options<StatsAdminControllerPeriodData, ThrowOnError>,
): RequestResult<StatsAdminControllerPeriodResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StatsAdminControllerPeriodResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/admin/stats/period",
    ...options,
  });
